<template>
    <Carousel @clicked="clickedCarousel">
        <div v-for="(image, index) in images" :key="image.id" :class="['carousel-item', (index === 0 ? 'active': '')]" >
            <img v-lazy="image.url" class="img-fluid d-block w-100 h-100 progImg">
            <img v-if="image.url === undefined" v-lazy="'https://via.placeholder.com/230x150/'" class="d-block w-100 progImg">
        </div>
    </Carousel>
</template>

<script>
import Carousel from '@/components/common/Carousel'
export default {
    name: 'ImageCarousel',
    components: {
        Carousel
    },
    props: {
        images: {
            type: Array,
            required: true,
            default: function() {
                return [];
            }
        }
    },
    methods: {
        clickedCarousel: function(val) {
            // This is a simple passthrough
            this.$emit('clickedImage');
        },
    }

}
</script>

<style lang="scss" scoped>
// .carousel-inner {
//     max-height: 300px;
// }

.progImg {
    object-fit: cover; 
}
</style>